import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0C10] px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Kembali ke situs
        </Link>
        <div className="rounded-3xl border border-white/10 bg-[#12141C] p-8">
          <div className="mb-6 flex items-center gap-3">
            <img src="/assets/logo.png" alt="BigBerry" className="h-12 w-12 rounded-lg" />
            <div>
              <h1 className="font-heading text-xl font-700 text-white">Admin BigBerry</h1>
              <p className="text-xs text-gray-500">Kelola katalog produk</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-gray-300">Email</Label>
              <Input
                id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="mt-1.5 border-white/10 bg-white/5 text-white focus-visible:ring-berry"
                placeholder="admin@bigberry.com"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-gray-300">Password</Label>
              <Input
                id="password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="mt-1.5 border-white/10 bg-white/5 text-white focus-visible:ring-berry"
                placeholder="••••••••"
              />
            </div>
            {error && <p data-testid="admin-error" className="text-sm text-red-400">{error}</p>}
            <button
              type="submit" disabled={loading}
              data-testid="admin-login-submit"
              className="flex w-full items-center justify-center gap-2 rounded-full bg-berry px-6 py-3 font-semibold text-white transition-colors hover:bg-berry-dark disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
              Masuk
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
